import React, { useContext, useState, useEffect, FC } from 'react';
import ConfigModel from '../Model/ConfigModel';

interface IConfigContext {
    configKeys: ConfigModel,
    getServiceUrl: () => string,
    getTranslationServiceUrl: () => string,
    isConfigLoaded : boolean,
    checkInternalVersion: () =>  boolean
}

interface IConfigProvider {
    children?: React.ReactNode
}

const defaultConfigContext:IConfigContext = {
    configKeys: new ConfigModel(),
    getServiceUrl: () => "",
    getTranslationServiceUrl: () => "",
    isConfigLoaded : false,
    checkInternalVersion: () =>  false
}

const ConfigContext = React.createContext<IConfigContext>(defaultConfigContext);
export const UseConfigContext = () => useContext(ConfigContext);

export const ConfigContextProvider:FC<IConfigProvider> = ({children}) => {
    const [configKeys, setConfigKeys] = useState(defaultConfigContext.configKeys);
    const [isConfigLoaded, setIsConfigLoaded] = useState(defaultConfigContext.isConfigLoaded);

    useEffect(() => {
        fetch("./Config.json")
            .then(response => response.json())
            .then(data => setConfigKeys(data as ConfigModel))
            .then(() => setIsConfigLoaded(true))
    }, []);

    const getServiceUrl = () => {
        switch(configKeys.currentEnv){
            case "DEV":
                return configKeys.salarysimService_DEV;
            case "QA":
                return configKeys.salarysimService_QA;
            case "PROD":
                return configKeys.salarysimService_PROD;
            case "LOCAL":
            default:
                return configKeys.salarysimService_LOCAL;
        }
    }

    const getTranslationServiceUrl = () => {
        switch(configKeys.currentEnv){
            case "DEV":
                return configKeys.translationService_DEV;
            case "QA":
                return configKeys.translationService_QA;
            case "PROD":
                return configKeys.translationService_PROD;
            case "LOCAL":
            default:
                return configKeys.translationService_LOCAL;
        }
    }

    const checkInternalVersion = () => {
        if(configKeys.version.toUpperCase() === 'INTERNAL')
        {
            return true;
        }
        else
        {
            return false;
        }
    }

    return(
        <ConfigContext.Provider value={{configKeys, getServiceUrl, getTranslationServiceUrl, isConfigLoaded, checkInternalVersion}}>{children}</ConfigContext.Provider>
    );
}